import './less/menuList.less';

const menuList = () => {
    
    
    let init = () => {}
    
    return init();
    
}

const menu = menuList();

export default menu;


// WEBPACK FOOTER //
// ./components/menuList/menuList.js